import ReactGA from "react-ga";

export const sendEvent = (category: string, action: string, label?: string, value?: number): void => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
    value: value,
  });
};

export const initialize = (key: string): void => {
  ReactGA.initialize(key, {
    gaOptions: {
      // fixes data collection in iframe
      // https://discuss.dev.twitch.tv/t/google-analytics-stopped-collecting-data-from-the-extension/29628/2
      cookieFlags: "max-age=7200;secure;samesite=none",
    },
  });

  // flag required by twitch policy
  ReactGA.set({ anonymizeIp: true });
};

export const setPage = (page: string): void => {
  ReactGA.ga("set", "page", page);
  ReactGA.ga("send", "pageview");
};

export default {
  sendEvent,
  initialize,
  setPage,
};
